import React from 'react'
import { useDispatch } from 'react-redux'
import { hideModal, ModalType } from '@landscape/ui-redux'
import { Modal as CBModal, PrimaryButton, NakedButton } from '@cb/apricot-react'
import { Glyph } from '@cb/apricot-react-glyph'
import styled from 'styled-components'

interface ModalFooterProps {
  children: React.ReactNode
}

const ModalFooter: React.FC<ModalFooterProps> = (props) => {
  return (
    <div className="cb-modal-footer">
      <div className="cb-btn-row">{props.children}</div>
    </div>
  )
}

export const TitleDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export interface ModalProps {
  key: string
  options: ModalType
}

export const glyphLookup = {
  success: { circular: true, color: 'green1', name: 'check' },
  warning: { circular: true, color: 'orange1', name: 'exclamation' },
  danger: { circular: true, color: 'red1', name: 'error' },
}

const Modal: React.FC<ModalProps> = (props) => {
  // used to dispatch actions to the redux store, triggering state change
  const dispatch = useDispatch()

  const {
    body,
    cancelFunction = () => {},
    cancelLabel,
    confirm = false,
    handlerFunction = () => {},
    exitFunction,
    primaryLabel,
    showModal,
    status,
    title: modalTitle,
    contactInfo = false,
    primaryDisabled = false,
  } = props.options
  // Function to close/remove the modal fro view
  function onClose() {
    dispatch(hideModal())
  }

  // Only used when confirm === true
  // cancel handler
  function onModalCancel() {
    cancelFunction()
    dispatch(hideModal())
    if (exitFunction) {
      exitFunction()
    }
  }

  // only used when confirm === true
  // success handler
  function onModalConfirm() {
    handlerFunction()
    dispatch(hideModal())
    if (exitFunction) {
      exitFunction()
    }
  }

  const title = (
    <TitleDiv>
      <Glyph {...glyphLookup[status]}></Glyph>
      <span style={{ marginLeft: '8px' }}>{modalTitle}</span>
    </TitleDiv>
  )

  // IF confirm === true, this modal has confirm/cancel functionality
  // if confirm === false, this is just an info modal
  let footerButtons
  if (confirm) {
    footerButtons = (
      <ModalFooter>
        <NakedButton onClick={onModalCancel}>{cancelLabel}</NakedButton>
        {primaryLabel && (
          <PrimaryButton disabled={primaryDisabled} id="ls-modal-prim-btn" onClick={onModalConfirm}>
            {primaryLabel}
          </PrimaryButton>
        )}
      </ModalFooter>
    )
  } else {
    footerButtons = (
      <ModalFooter>
        <NakedButton onClick={onModalCancel} className="modal-accept-btn">
          Ok
        </NakedButton>
      </ModalFooter>
    )
  }

  return (
    <CBModal
      // from docs: https://atlas.collegeboard.org/cb-component-store/index.html?path=/story/apricot-apricot-react-modal--readme
      // used to add extra buttons to the modal. see keyword ACTIONS
      footer={footerButtons}
      open={showModal}
      title={title}
      onClose={onClose}
    >
      {body && body.length ? (
        <div className="modal-body">
          <div
            className="model-content-component"
            style={{ whiteSpace: 'pre-line', textAlign: 'left', fontSize: '.9rem' }}
          >
            {body}
            {contactInfo && (
              <div className="cb-margin-top-16">
                Contact{' '}
                <a href="mailto:futureadmissions@collegeboard.org">
                  {' '}
                  futureadmissions@collegeboard.org
                </a>{' '}
                with any questions.
              </div>
            )}
          </div>
        </div>
      ) : null}
    </CBModal>
  )
}

export { Modal }
